"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegoeWoff2 = exports.SegoeWoff = void 0;
const Segoe_UI_woff_1 = __importDefault(require("./Segoe-UI.woff"));
exports.SegoeWoff = Segoe_UI_woff_1.default;
const Segoe_UI_woff2_1 = __importDefault(require("./Segoe-UI.woff2"));
exports.SegoeWoff2 = Segoe_UI_woff2_1.default;
//# sourceMappingURL=fonts.js.map